import JSONRPC from './JSONRPC';
import type { JsonRpcTransport } from './types/JSONRPCAPI';
import type {
  MiniGDataColorants,
  MiniGDataGenerateResponse,
  MiniGDataList,
  MiniGDataQtObject,
} from './types/MiniGData';

export type {
  MiniGDataColorant,
  MiniGDataColorants,
  MiniGDataGenerateResponse,
  MiniGDataList,
  MiniGDataSystem,
  MiniGDataQtObject,
} from './types/MiniGData';

function createNullJsonRpc(): JsonRpcTransport {
  return {
    request: <T = unknown>() => Promise.resolve(null as T),
    handleResponse: () => undefined,
  };
}

export class MiniGDataApi {
  private jsonrpc: JsonRpcTransport;

  // dummy dispatcher that resolves all calls to null
  constructor() {
    // dummy dispatcher that resolves all calls to null
    this.jsonrpc = createNullJsonRpc();
  }

  connect(qtobject: MiniGDataQtObject): void {
    // connecting all machine actions here
    try {
      this.jsonrpc = new JSONRPC((message) =>
        qtobject.dispatch(JSON.stringify(message))
      );
      qtobject.response.connect((str: string) =>
        this.jsonrpc.handleResponse(JSON.parse(str))
      );
    } catch (e) {
      console.log(e);
      this.jsonrpc = createNullJsonRpc();
    }
  }

  generate_minigdata(
    cnts: MiniGDataColorants
  ): Promise<MiniGDataGenerateResponse> {
    return this.jsonrpc.request<MiniGDataGenerateResponse>(
      'generate_minigdata',
      [cnts]
    );
  }

  list_minigdata(): Promise<MiniGDataList> {
    return this.jsonrpc.request<MiniGDataList>('list_gdatas');
  }
}
const api = new MiniGDataApi();

export { api as default };
